import {
  Box,
  Button,
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { Icon } from "@iconify/react";
import useResponsive from "../../../../../Hooks/useResponsive";
import AppraiseeProgress from "./AppraiseeProgress";
import ActionMenu from "./ActionMenu";

const AppraisalCycleCard = ({
  data,
  setDeleteCycle,
  setManageUser,
  setClone,
  handleCurrentData,
  setRunCycle,
  setCreateCycle,
  setEditStatus,
  setStatus,
  setManage,
  setRestartCycle
}) => {
  const smUp = useResponsive("up", "sm");
  const mdUp = useResponsive("up", "md");
  const {
    appraisal_cycle_name,
    evaluation_period,
    created_on,
    completed_percentage,
    total_appraisee,
    cycle_status,
    appraisal_cycle_id,
  } = data;
  return (
    <Box>
      <Paper
        sx={{
          border: 0.4,
          borderColor: "grey.300",
          mt: 2,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: mdUp ? "row" : "column",
          borderRadius: 2,
          transition: "box-shadow 0.3s ease",
          "&:hover": {
            boxShadow: 3,
            ".rotating-icon": {
              animation: "spin 3s linear infinite",
            },
          },
          "@keyframes spin": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(360deg)" },
          },
        }}
      >
        <Box>
          {/* ---------------------------------------------------------- */}
          <Stack direction={"row"} spacing={1}>
            <Box
              className="rotating-icon"
              sx={{
                backgroundColor: "#2f72b342",
                color: "#2f72b3",
                height: 40,
                width: 40,
                borderRadius: "50%",
                p: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon icon="ix:cycle" width="18" height="18" />
            </Box>
            <Box sx={{ pt: 1 }}>
              <Typography variant="subtitle1">
                {appraisal_cycle_name}
              </Typography>
            </Box>
          </Stack>
          {/* -=------------------------------------------------------- */}
          <Stack direction={smUp ? "row" : "column"} spacing={1} sx={{ ml: 6 }}>
            <Box sx={{ mb: 0.5 }}>
              <Chip
                sx={{ fontSize: 10 }}
                size="small"
                color="primary"
                icon={<Icon icon="stash:data-date" width="18" height="18" />}
                variant="outlined"
                label={evaluation_period}
              />
            </Box>
            {/* <Divider /> */}
            <Box>
              <Chip
                icon={<Icon icon="stash:data-date" width="18" height="18" />}
                sx={{ fontSize: 10 }}
                size="small"
                label={`Created On : ${created_on}`}
              />
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", mt: mdUp ? "" : 1 }}
        >
          <AppraiseeProgress
            progress={completed_percentage}
            total={total_appraisee}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <ActionMenu
              data={data}
              setDeleteCycle={setDeleteCycle}
              setManageUser={setManageUser}
              setClone={setClone}
              handleCurrentData={handleCurrentData}
              setCreateCycle={setCreateCycle}
              setEditStatus={setEditStatus}
              setStatus={setStatus}
              setManage={setManage}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              size="small"
              variant="outlined"
              disabled={cycle_status === 2}
              color={data.cycle_status === 0 ? "success" : "error"}
              sx={{ borderRadius: 3 }}
              onClick={() => {
                handleCurrentData(data);
                setRunCycle(true);
              }}
            >
              {cycle_status === 0
                ? "Run Cycle"
                : cycle_status === 2
                ? "Cycle Stopped"
                : "Stop Cycle"}
            </Button>
          </Box>
          {cycle_status === 2 && (
            <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ml:1,
            }}
          >
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              // disabled={cycle_status === 2}
              // color={data.cycle_status === 0 ? "success" : "error"}
              sx={{ borderRadius: 3 }}
              onClick={() => {
                handleCurrentData(data);
                setRestartCycle(true);
              }}
              startIcon={<Icon icon="mdi:restart" />}
            >
              Restart Cycle
            </Button>
          </Box>
            )}
        </Box>
      </Paper>
    </Box>
  );
};

export default AppraisalCycleCard;
